import { render, staticRenderFns } from "./InzamelingForm.vue?vue&type=template&id=0089434b&scoped=true"
import script from "./InzamelingForm.vue?vue&type=script&lang=js"
export * from "./InzamelingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089434b",
  null
  
)

export default component.exports